export default class CookieProxy {
  constructor(target) {
    this._target = target;
    this._proxyEnabled = false;
    this._cookies = {};
  }
  get(name, ...args) {
    if (this._proxyEnabled === true) {
      return typeof this._cookies === 'object' ? (this._cookies[name] || '') : '';
    }
    return this._target.get(name, ...args);
  }
  set(...args) {
    return this._target.set(...args);
  }
  remove(...args) {
    return this._target.remove(...args);
  }
  setCookies(cookies = {}) {
    this._cookies = cookies;
  }
  getCookies() {
    return this._cookies;
  }
  enableProxy() {
    this._proxyEnabled = true;
  }
  disableProxy() {
    this._proxyEnabled = false;
  }
  isProxyEnabled() {
    return this._proxyEnabled;
  }
}
